import { render, staticRenderFns } from "./NetPremiumUsdProperty.vue?vue&type=template&id=636e6d2c&scoped=true&"
import script from "./NetPremiumUsdProperty.vue?vue&type=script&lang=js&"
export * from "./NetPremiumUsdProperty.vue?vue&type=script&lang=js&"
import style0 from "./NetPremiumUsdProperty.vue?vue&type=style&index=0&id=636e6d2c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636e6d2c",
  null
  
)

export default component.exports